// extracted by mini-css-extract-plugin
module.exports = {"container":"CameraView_container__3Rio7","video":"CameraView_video__2i3Er","hiddenCanvas":"CameraView_hiddenCanvas__1AcE7","overlay":"CameraView_overlay__Nzyrp"};